import { useNavigate } from '@tanstack/react-router';

import { Button } from 'components/Button/Button';
import Tooltip from 'components/Tooltip/Tooltip';

import useAppLanguage from 'hooks/useAppLanguage';

import { OrderTypeModalCallable } from 'app/_authenticated/trade/components/OrderTypeModal/OrderTypeModal';
import { ProductWithHoldingsAndRates } from 'hooks/products/useProducts';
import messages from '../messages';

function ProductButtons({
  product,
  earlyAccessLink,
  earlyAccessText,
  redeemLink,
  isVerified,
}: {
  product: ProductWithHoldingsAndRates;
  isVerified: boolean;
  earlyAccessLink?: string;
  earlyAccessText?: string;
  redeemLink?: string;
}) {
  const language = useAppLanguage();
  const productButtonsMessages = messages[language]?.productData;

  const handleBuy = (code: string) => {
    OrderTypeModalCallable.call({ productCode: code, filter: 'buy' });
  };

  const handleSell = (code: string) => {
    OrderTypeModalCallable.call({ productCode: code, filter: 'sell' });
  };

  return (
    <>
      <div className="wrap flex w-full justify-between">
        {product.isBuyable && (
          <Button
            onClick={() => {
              handleBuy(product.code);
            }}
            main
            full
            className="mr-4">
            {productButtonsMessages.investBtn}
          </Button>
        )}
        {product.isSellable &&
          product.totalAmount > 0 &&
          (product.availableAmount > 0 ? (
            <Button onClick={() => handleSell(product.code)} main full>
              {productButtonsMessages.sellBtn}
            </Button>
          ) : (
            <Tooltip
              id="noSell"
              darkBg
              content={
                <div>{productButtonsMessages.noSell(product.code)}</div>
              }>
              <div className="w-full">
                <Button
                  main
                  full
                  clickBlocked
                  type="button"
                  onClick={undefined}>
                  {productButtonsMessages.sellBtn}
                </Button>
              </div>
            </Tooltip>
          ))}
      </div>

      <div className="wrap flex justify-between mx-6 px-2">
        {earlyAccessLink && isVerified && (
          <div className="-mb-4 lg:-mt-4 lg:-mb-6 basis-full self-stretch flex flex-row gap-4 p-0 flex-wrap">
            <div className="flex basis-full lg:basis-[calc(50%-0.5rem)]">
              <Button
                main
                full
                disabled
                className='bg-[#888] text-[#FFFFFF]'
                onClick={() => {
                  window.open(earlyAccessLink, '_blank');
                }}>
                {'Investment Closed'}
              </Button>
            </div>
            <div className="flex basis-[calc(50%-0.5rem)] hidden lg:block">
              <Button
                outlined
                full
                underline
                onClick={() => {
                  window.open(
                    product.totalAmount > 0
                      ? redeemLink
                      : import.meta.env.VITE_ALTIFY_CDN_URL +
                          product.factsheetUrl,
                    '_blank',
                  );
                }}
                className="w-full border border-white hover:border-primary hover:text-primary h-12">
                {product.totalAmount > 0
                  ? productButtonsMessages.redeemButton
                  : productButtonsMessages.downloadFactsheet}
              </Button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ProductButtons;
